import { useMemo, useEffect, useState } from 'react';
import { Container,  Card, CardBody, Col, Row, CardHeader } from 'reactstrap';
import { useParams , Link } from 'react-router-dom';
import BreadCrumb from  "../Components/Common/BreadCrumb";
import TableContainer from "../Components/Common/TableContainer";
import Chart from "../Components/Common/Chart";
import ReactTooltip from 'react-tooltip';
import { formatyocto , format } from '../helpers/lib';
import parasicon from '../assets/images/near/paras.png';
import Loader from '../Components/Common/Loader';
import FeatherIcon from "feather-icons-react";

export default function CollectionProfile(props){

    let { collectionId } = useParams();

    const [data, setData] = useState(null);
    const [historic, setHistoric] = useState(null);
    const [tableData, setTableData] = useState(null);
    const [ready, setReady] = useState(false);
    const [volume, setVolume] = useState(null);
    const [dateSale, setDateSale] = useState(null);

    const init = async () => {
        
        let requestCollectionsId = await fetch(process.env.REACT_APP_API_URL + '/collections?collection_id=' + collectionId);
        let resultCollectionsId = await requestCollectionsId.json();
        let requestCollectionDailyId = await fetch(process.env.REACT_APP_API_URL + '/collection-daily?collection_id=' + collectionId);
        let resultCollectionDailyId = await requestCollectionDailyId.json();
        

        let requestCollectionActivities = await fetch(process.env.REACT_APP_API_URL + '/collection-activities?collection_id=' + collectionId + '&filter=sale&__skip=0&__limit=10&__sort=des_issued_at');
        let resultCollectionActivities = await requestCollectionActivities.json();

        //console.log("profile",data);

        let colsVolume = [];
        let colsDate = [];
        let colsTableData = [];

        for(let collection of resultCollectionDailyId.data.volume_daily.slice(15,29)){
        
            let opSale = String(formatyocto(collection.volume,0) + "Ⓝ");
            let opDate = String(collection.date).substring(5,10);
            
            colsVolume.push(opSale);
            colsDate.push(opDate);

        }
        let colsVolumeComplete = await Promise.all(colsVolume);
        let colsDateComplete = await Promise.all(colsDate);
        //console.log("All Table helper",colsTableData);

        for(let collection2 of resultCollectionActivities.data){

            let metadataTitle = collection2.data.map((metad)=>metad.metadata.title);
            let metadataImage = collection2.data.map((metad)=>metad.metadata.media);

            let opDate = collection2.msg.datetime;
            let opTitle = metadataTitle;
            let opImage = String(metadataImage);
            let isHttp = opImage.includes("://");
            let opFrom = collection2.from;
            //console.log('From', isHttp);
            let opOwner = collection2.to;
            //console.log('Owner', opOwner)
            let opSale = String( formatyocto(collection2.price)+" Ⓝ");
            let opStatus = collection2.type;
            let ipfspic 
            if (isHttp > 0 ) {
                ipfspic = 'https://images.cloudflare-dev.workers.dev/image-resizing?width=80&image=' + opImage 
            }else{
                ipfspic = 'https://images.cloudflare-dev.workers.dev/image-resizing?width=80&image=' + process.env.REACT_APP_IPFS_URL2 + "/" + opImage
            } 

            colsTableData.push(
                {   
                    title: 
                    <>
                        <div className="d-flex align-items-center">
                            <img alt="" className="avatar-md rounded" src={ipfspic} />

                        <div className="ms-3">                                            
                                <p className="mb-0 text">{opTitle}</p>
                            </div> 
                        </div>
                    </>,
                    from: 
                    <>
                        <>
                        <button data-tip data-for={opDate+"registerTipFrom"} className='toolTipButton'><h6>{String(opFrom).substring(0,16)}</h6></button> 
                        <ReactTooltip id={opDate+"registerTipFrom"} place="top" effect="solid">{opFrom}</ReactTooltip>
                        </>
                    </>,
                    owner: 
                    <>

                        <>
                        <button data-tip data-for={opDate+"registerTipOwner"} className='toolTipButton'><h6>{String(opOwner).substring(0,16)}</h6></button> 
                        <ReactTooltip id={opDate+"registerTipOwner"} place="top" effect="solid"><h6>{opOwner}</h6></ReactTooltip>
                        </>
                    </>
                    ,
                    date: String(opDate).substring(0,10),
                    price: opSale,
                    operation: opStatus
                }
                
            );
        }
        let colsTableDataComplete = await Promise.all(colsTableData);
        setReady(true);
        setVolume(colsVolumeComplete);
        setDateSale(colsDateComplete);
        setHistoric(resultCollectionDailyId);
        setData(resultCollectionsId.data.results[0]);
        setTableData(colsTableDataComplete);
        //console.log("Complete",colsTableDataComplete);
    };

    useEffect(() => {
        init();
    }, []);

    const columns = useMemo(
        () => [
            {                
                Header: "Title",
                accessor: "title",
                filterable: false,
            },{                
                Header: "Price",
                accessor: "price",
                filterable: false,
            }, 
            {                
                Header: "From",
                accessor: "from",
                filterable: false,
            },
            {                
                Header: "Owner",
                accessor: "owner",
                filterable: false,
            },
            {                
                Header: "Date",
                accessor: "date",
                filterable: false,
            },                       {                
                Header: "Operation",
                accessor: "operation",
                filterable: false,
            }
        ],
    []);
    //console.log("DATA", data);
    if(!data) {
        return <div className="page-content">
            <Container fluid={true}>
                <Loader />
            </Container>
        </div>
    }

    return ((<div className="page-content">
            <Container fluid={true}>
                
                <BreadCrumb title="Collection Profile" breadcrumbItem="Collection Profile" />
                
                <Row>

                    <Col md={3}>
                        <Card className={"card-animate"}>
                            <CardHeader className="border-0 align-items-center d-flex">
                                <h2 className="card-title mb-0 flex-grow-1 fs-2">{data.collection}</h2>
                            </CardHeader>
                            <CardBody>
                            
                                <img alt="" src={'https://images.cloudflare-dev.workers.dev/image-resizing?width=80&image=' + process.env.REACT_APP_IPFS_URL2 + '/' + data.media} style={{maxWidth: '100%'}} className="rounded" />
                                
                                <div className="d-flex flex-wrap gap-2 mt-4 text-center">
                                {( data.socialMedia ) ? <>
                                    {(data.socialMedia.discord && data.socialMedia.discord !== "" && data.socialMedia.discord != null) ?  
                                        <div>
                                            <a href={data.socialMedia.discord.includes("htt") ? `${data.socialMedia.discord}` : `https://discord.gg/${data.socialMedia.discord}`} className="avatar-xs d-block" target="_blank" rel="noreferrer noopener">       
                                                <span
                                                    className="avatar-title rounded-circle fs-16 bg-soft-dark text-dark text-center text-light">
                                                    <i className="ri-discord-fill"></i>
                                                </span>
                                            </a>
                                        </div> : <></> }

                                    {( data.socialMedia.twitter && data.socialMedia.twitter !== "" && data.socialMedia.twitter != null) ?
                                    <div>
                                        <a href={data.socialMedia.twitter.includes("htt") ? `${data.socialMedia.twitter}` : `https://twitter.com/${data.socialMedia.twitter}` } className="avatar-xs d-block" target="_blank" rel="noreferrer noopener">
                                            <span
                                                className="avatar-title rounded-circle fs-16 bg-soft-dark text-dark text-light">
                                                <i className="ri-twitter-fill"></i>
                                            </span>
                                        </a>
                                    </div>: ""}
                                    {( data.socialMedia.website && data.socialMedia.website != null && data.socialMedia.website !== "") ?
                                    <div>
                                        <a href={ data.socialMedia.website.includes("htt") ? `${data.socialMedia.website}` : `https://${data.socialMedia.website}` } className="avatar-xs d-block" target="_blank" rel="noreferrer noopener">
                                            <span
                                                className="avatar-title rounded-circle fs-16 bg-soft-dark text-dark text-light">
                                                <i className="ri-global-fill"></i>
                                            </span>
                                        </a>
                                    </div>: ""}
                                    </> : ""
                                }
                                    
                                    <div>
                                        <a href={ `https://paras.id/collection/${data.collection_id}`} className="avatar-xs d-block" target="_blank" rel="noreferrer noopener">
                                            <span
                                                className="avatar-title rounded-circle fs-16 bg-soft-dark text-dark text-light">
                                                <img src={parasicon} alt="paras" className="rounded-circle avatar-xxs" />
                                            </span>
                                        </a>
                                    </div>

                                </div>                        
                                <div className="mt-4">
                                    {data.description}
                                </div>
                            </CardBody>
                        </Card>


                        <Card className={"card-animate"}>
                            <CardHeader className="border-0 align-items-center d-flex">
                                <h4 className="card-title mb-0 flex-grow-1">Sales volume :</h4>
                                
                            </CardHeader>
                            <CardBody>
                                {historic && !!historic &&
                                
                                    <Chart dataColors='["#2a81b3"]' datasale={volume} datadate={dateSale} />
                                }
                            </CardBody>
                        </Card>

                    </Col>

                    <Col md={9}>
                        <Row>
                            <Col md={4}>
                                <Card className={"card-animate"}>
                                    <CardBody>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h5 className="text-muted text-uppercase fs-13">Total volume</h5>
                                                <h2 className="mt-4 ff-secondary fw-semibold ">
                                                    {format(formatyocto(data.volume) * 1)} Ⓝ
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="avatar-sm flex-shrink-0">
                                                    <span className="avatar-title rounded-circle fs-2 bg-soft-primary">
                                                        <FeatherIcon
                                                            icon="trending-up"
                                                            className="text-success"
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card className={"card-animate"}>
                                    <CardBody>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h5 className="text-muted text-uppercase fs-13">Floor price</h5>
                                                <h2 className="mt-4 ff-secondary fw-semibold ">
                                                {formatyocto(data.floor_price)} Ⓝ
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="avatar-sm flex-shrink-0">
                                                    <span className="avatar-title rounded-circle fs-2 bg-soft-primary">
                                                        <FeatherIcon
                                                            icon="activity"
                                                            className="text-primary"
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card className={"card-animate"}>
                                    <CardBody>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <h5 className="text-muted text-uppercase fs-13">Avg price</h5>
                                            <h2 className="mt-4 ff-secondary fw-semibold ">
                                            {formatyocto(data.avg_price)}  Ⓝ
                                            </h2>
                                        </div>
                                        <div>
                                            <div className="avatar-sm flex-shrink-0">
                                                <span className="avatar-title rounded-circle fs-2 bg-soft-primary">
                                                    <FeatherIcon
                                                        icon="bar-chart-2"
                                                        className="text-primary"
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                            </Col>

                        </Row>

                        <Row>
                            <Col md={4}>
                                <Card className={"card-animate"}>
                                    <CardBody>
                                    <div className="d-flex justify-content-between">
                                            <div>
                                                <h5 className="text-muted text-uppercase fs-13">Total sales</h5>
                                                <h2 className="mt-4 ff-secondary fw-semibold ">
                                                {data.total_sales}
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="avatar-sm flex-shrink-0">
                                                    <span className="avatar-title rounded-circle fs-2 bg-soft-primary">
                                                        <FeatherIcon
                                                            icon="arrow-up"
                                                            className="text-primary"
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            
                            <Col md={4}>
                                <Card className={"card-animate"}>
                                    <CardBody>
                                    <div className="d-flex justify-content-between">
                                            <div>
                                                <h5 className="text-muted text-uppercase fs-13">Total owners</h5>
                                                <h2 className="mt-4 ff-secondary fw-semibold ">
                                                {data.total_owners}
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="avatar-sm flex-shrink-0">
                                                    <span className="avatar-title rounded-circle fs-2 bg-soft-primary">
                                                        <FeatherIcon
                                                            icon="users"
                                                            className="text-primary"
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={4}>
                                <Card className={"card-animate"}>
                                    <CardBody>
                                    <div className="d-flex justify-content-between">
                                            <div>
                                                <h5 className="text-muted text-uppercase fs-13">Total cards</h5>
                                                <h2 className="mt-4 ff-secondary fw-semibold ">
                                                {data.total_cards}
                                                </h2>
                                            </div>
                                            <div>
                                                <div className="avatar-sm flex-shrink-0">
                                                    <span className="avatar-title rounded-circle fs-2 bg-soft-primary">
                                                        <FeatherIcon
                                                            icon="layers"
                                                            className="text-primary"
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <Card className={"card-animate"}>
                                    <CardHeader className="border-0 align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Last Sales</h4>
                                    </CardHeader>
                                    <CardBody>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="card" id="contactList">
                                                <div className="card-body pt-0">
                                                    {!!tableData &&
                                                        <TableContainer                        
                                                            columns={columns}
                                                            data={(tableData || [])}
                                                            isGlobalFilter={false}

                                                            customPageSize={10}
                                                            className="custom-header-css"
                                                            divClass="table-responsive table-card mb-1"
                                                            tableClass="align-middle table-nowrap"
                                                            theadClass="table-light text-muted"
                                                            isNFTRankingFilter={false}
                                                            />
                                                    }
                                                    {!tableData &&
                                                        <Loader />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>                       
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                    </Col>

                    
                </Row>
                
            
                
            </Container>
        </div>));
}